import { Pipe, PipeTransform } from '@angular/core';
import { LanguageModel } from '../../../services';

@Pipe({
  name: 'isDefaultLanguage'
})
export class IsDefaultLanguagePipe implements PipeTransform {

  constructor() {
  }

  transform(language: LanguageModel): boolean {
    return language.data.isdefault && language.data.isdefault.iv === true;
  }
}
